/*
 * Copyright (c) 2020.
 *
 * Robert Siennicki (rs@bananahouse.pl)
 * http://bananahouse.pl
 */

function createGA4EcommerceImpression($item){
    let price = $item.find('.actual-price .price-value').text().trim().replace(' ', '');
    let discount = 0;
    if($item.find('.old-price').length){
        discount = $item.find('.old-price .price-value').text().trim().replace(' ', '') - price;
    }
    if(discount < 0){
        discount = 0;
    }
    return {
        item_id: $item.data('idaggregate'),
        item_name: $item.find('.brand-name').text()+' '+$item.find('.model-name').text(),
        coupon: '',
        currency: 'PLN',
        discount: discount,
        index: $item.parent().index(),
        item_brand: $item.find('.brand-name').text(),
        item_category: $item.data('finance-name'),
        item_category2: $item.data('offer-name'),
        item_category3: $item.find('.version-name').text(),
        item_category4: $item.data('fuel-name'),
        item_category5: $item.data('transmission-name'),
        item_list_id: $item.data('contract-period'),
        item_list_name: $item.data('listing-name'),
        item_variant: $item.find('.type-name').text(),
        location_id: $item.data('natcode'),
        promotion_id: $item.data('promo'),
        promotion_name: $item.data('promo-name'),
        price: price,
        quantity: '1'
    };
}

function sendGA4EcommerceTags($items, $data) {
    if(!$items.length){
        return;
    }

    $data = $data ?? {};
    let $impressions = [];
    $items.each(function(){
        let $item = $(this).find('.offer-thumb');
        let $impression = createGA4EcommerceImpression($item);
        if($impression.item_id){
            $impressions.push($impression);
        }
    });

    let dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push($.extend({}, {
        'event': 'view_item_list',
        'ecommerce': {
            'items': $impressions
        }
    }, $data));
}

export function createEcommerceImpression($item){
    return {
        'id': $item.data('idaggregate'),
        'name': $item.find('.brand-name').text()+' '+$item.find('.model-name').text(),
        'price': $item.find('.actual-price .price-value').text().trim().replace(' ', ''),
        'brand': $item.find('.brand-name').text(),
        'category': $item.find('.version-name').text(),
        'list': '',
        'position': $item.parent().index(),
    };
}

function sendUAEcommerceTags($items) {
    if(!$items.length){
        return;
    }

    let $impressions = [];
    $items.each(function(){
        let $item = $(this).find('.offer-thumb');
        let $impression = createEcommerceImpression($item);
        if($impression.item_id){
            $impressions.push($impression);
        }
    });

    let dataLayer = window.dataLayer || [];
    dataLayer.push({
        'ecommerce': {
            'currencyCode': 'PLN',
            'impressions': $impressions
        }
    });
}

export function sendEcommerceTags($items) {
    sendGA4EcommerceTags($items);
    sendUAEcommerceTags($items);
}
